import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  message,
  Checkbox,
  Switch,
  Upload,
  Space,
  TimePicker,
  Button,
  Radio,
} from "antd";
import styled from "@emotion/styled";
import moment from "moment";
import {
  NON_EMPTY_REGEX,
  EMAIL_REGEX,
  countryList,
  Greetings,
  AwardList,
  STATUS_CODE,
  ContractingCompany,
  Industry,
  secondaryIndustry,
  Sector,
  IndustryRole,
  RegionalCometencyRole,
  Grade,
} from "common/Constants";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isEmpty } from "lodash";
import { CALL_API } from "common/API";

const StyleRow = styled(Row)`
  padding: 10px;
  box-shadow: 0px 3px 6px #00000015;
  .ant-form-item-label {
    text-align: left;
  }
  #country {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  .empty_col{
    width: 30%;
  }

  .ant-btn.ant-btn-default {
    border: none;
    background: #f4f4f4;
    color: #000;
    border-radius: 6px;
  }
  .ant-upload-list.ant-upload-list-text {
    margin-top: 20px;
  }
  .cv_file {
    .ant-upload-list.ant-upload-list-text {
      margin-top: 0px;
    }
  }
  .ant-upload-list-item.ant-upload-list-item-undefined {
    background-color: #badaf9 !important;
  }
  .ant-upload-wrapper .ant-upload-list .ant-upload-list-item {
    position: relative;
    height: 35px;
    margin-top: 8px;
    padding: 5px;
    font-size: 14px;
    display: flex;
    align-items: center;
    background-color: rgb(194, 250, 229);
    transition: background-color 0.3s;
  }
  .attach_btn_cv{
    background: #badaf9;
    margin-top: 28px;
    height: 35px;
    color: #4b4b4bc7;
    border-radius: 6px;
    padding: 5px;
  }

  .attach_btn {
    background-color: #badaf9;
    margin-top: 28px;
    height: 35px;
    color: #4b4b4bc7;
    border-radius: 6px;
    padding: 5px;
  }
  /* .attach_btn_2 {
    background-color: #badaf9 !imporatnt;
    height: 35px;
    color: #4b4b4bc7;
    border-radius: 6px;
    padding: 5px;
    ::before{
      background-color: #badaf9 !imporatnt;
    }
  } */
  .ant-btn-default{
    background-color: rgb(194, 250, 229) !imporatnt;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    width: 0px;
  }
  
  .ant-radio-button-wrapper.ant-radio-button-wrapper-checked.ant-radio-button-wrapper-in-form-item {
    background-color: rgb(194, 250, 229) !imporatnt;
    color: #000;
  }
  .ant-picker {
    width: 100% !important;
  }
  .ant-upload.ant-upload-select {
    width: 100% !important;
    color: #397ff4 !important;
    background-color: rgb(194, 250, 229) !imporatnt;
    .ant-btn > span {
      display: inline-block;
      color: #397ff4;
    }
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      background-color: rgb(194, 250, 229) !imporatnt;
    }
    .ant-upload-list-picture .ant-upload-list-item,
    .ant-upload-list-picture-card .ant-upload-list-item {
      height: 40px;
    }
    .ant-upload-list-text .ant-upload-list-item-name,
    .ant-upload-list-picture .ant-upload-list-item-name {
      color: #397ff4;
    }
  }
  .css-1qjjar1 .ant-upload.ant-upload-select button, .css-1qjjar1 .ant-upload.ant-upload-select html [type="button"], .css-1qjjar1 .ant-upload.ant-upload-select [type="reset"], .css-1qjjar1 .ant-upload.ant-upload-select [type="submit"] {
    background: rgb(194, 250, 229) !imporatnt;
  }
  #country {
    width: 100%;
    display: -webkit-box;
    gap: 1rem;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .upload_Box_Style{
    background-color: rgb(194, 250, 229) !important;
  }


  @media (min-width: 600px) {
    .ant-btn.ant-btn-default {
      width: 100px;
    }
  }
  @media (max-width: 991px) {
    .empty_col {
      width: 100%;
    }
  }
`;

function WorkDetails({
  setStep,
  setFormValues,
  formValues,
  form,
  userData,
  supervisorList,
}) {
  const { Option } = Select;
  const containerRef = useRef(null);

  const [emailsList, setEmailList] = useState([]);
  const [fileList, setFileList] = useState();
  // const [formList, setFormList] = useState(form.getFieldsValue());
  const [selectedCountry, setSelectedCountry] = useState(userData?.country || "");
  const handleUploadChange = ({ fileList, file }, documentType) => {
    // uploadFile({ fileList, file });
    uploadFile({ fileList, file }, documentType);
    setFileList(fileList);
  };
  useEffect(() => {
    setSelectedCountry(userData?.country || "")
  }, [userData])

  const validateFiles = (rule, value) => {
    if (!value || value.length === 0) {
      return Promise.reject(new Error("File is required"));
    }
  
    const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
    
    const isValid = value.every(file => validTypes.includes(file.type));
    
    if (!isValid) {
      return Promise.reject(new Error("You can only upload PDF or image files!"));
    }
  
    return Promise.resolve();
  };

  function generateUniqueId() {
    const usedIds = [];
    let uniqueId = "";
    while (uniqueId.length !== 6) {
      const randomNumber = Math.floor(Math.random() * 900000) + 100000;
      if (!usedIds.includes(randomNumber.toString())) {
        usedIds.push(randomNumber.toString());
        uniqueId += randomNumber.toString();
      }
    }
    return uniqueId;
  }
  const uploadFile = async (value, documentType) => {
    const { file } = value;
    try {
      if (file && !isEmpty(file)) {
        // Base64 Conversion moved here
        const reader = new FileReader();

        reader.onload = async () => {
          const base64Data = reader.result.split(",")[1]; // Convert to base64
          const { userid = "" } = userData;
          const obj = {
            // userId: user_id?.toLowerCase(),
            name: file.name,
            type: file.type,
            documentType: documentType,
            documentName: documentType === "CV" ? "cv" : "identityinformation",
            uniqueId: file.uid,
            status: true,
            content: base64Data,
            identityName: documentType
          };

          await CALL_API(`upload-identity/${form.getFieldValue('clientid')}/${userid}`, "post", obj);
        };

        reader.onerror = (error) => {
          console.error("FileReader error:", error);
        };

        reader.readAsDataURL(file);
      }
    } catch (error) {
      console.error("[uploadFile] error --->", error);
    }
  };

  const handleClick = (country) => {
    setSelectedCountry(country);
  };

  const getEmailList = async () => {
    const response = await CALL_API(`add-users/email-list`, "get");
    if (response.code === STATUS_CODE.SUCCESS) setEmailList(response.response);
  };

  useEffect(() => {
    getEmailList();
    if (!isEmpty(formValues)) {
      form.setFieldsValue(formValues);
    }
  }, [formValues]);
  let formList = form.getFieldsValue();
  return (
    <div>
      <>
        <b className="my-2 mx-1">Work Information:</b>
        <StyleRow className=" mt-2 mb-3" gutter={20}>
          {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="overtime"
                  label="Overtime Eligible"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    getPopupContainer={() => containerRef.current}
                    
                  >
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item>
              </Col> */}
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="companyname"
              label="Company Name"
              rules={[
                {
                  required: false,
                  message: "Company name is required",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Company name"
                maxLength={50}

                onKeyDown={(e) => {
                  const allowedChars = /^[a-zA-Z\s]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Last Promotion Date"
              name="lastpromotiondate"
              rules={[
                {
                  required: false,
                  pattern: NON_EMPTY_REGEX,
                  message: "Last Promotion Date is required",
                },
              ]}
            >
              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"
                placeholder="Select Last Promotion Date"
                getPopupContainer={() => containerRef.current}

              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="lastpromotionlevel"
              label="Last Promotion Level"
              rules={[
                {
                  required: false,
                  message: "Last Promotion is required",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Last Promotion"
                maxLength={100}

              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="jobtitle"
              label="Job Title"
              rules={[
                {
                  required: true,
                  message: "Job title is required",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Job Title"
                maxLength={50}

                onKeyDown={(e) => {
                  const allowedChars = /^[a-zA-Z\s]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Professional Since"
              name="professionalsince"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Professional Since is required",
                },
              ]}
            >
              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"

                placeholder="Professional Since"
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Hired Date"
              name="hireddate"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Hired Date is required",
                },
              ]}
            >
              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"

                placeholder="Select Hired Date"
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="employeesponser"
              label="Employee Sponsor"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Employee Sponsor is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                getPopupContainer={() => containerRef.current}

              >
                <Option value="yes">Yes</Option>
                <Option value="no">No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="employeestatus"
              label="Status"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Status is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                disabled
                getPopupContainer={() => containerRef.current}
              // onChange={(value) => {
              //   // setEmployeeStatusId(value === "active" ? "1" : "0");
              // }}
              >
                <Option value="active">Active</Option>
                <Option value="in active">In active</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="relevent"
              label="Relevant"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Relevant is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                getPopupContainer={() => containerRef.current}

              >
                <Option value="yes">Yes</Option>
                <Option value="no">No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="employementtype"
              label="Employement Type"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Employement Type is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                getPopupContainer={() => containerRef.current}
                onChange={(value) => {
                  if (value !== "Probation") {
                    form.setFieldValue("probationstartdate", "");
                    form.setFieldValue("probationenddate", "");
                  }
                  if (value !== "Contract") {
                    form.setFieldValue("contractstartdate", "");
                    form.setFieldValue("contractenddate", "");
                  }
                }}
              >
                <Option value="Casual">Casual</Option>
                <Option value="Contract">Contract</Option>
                <Option value="Full time">Full time</Option>
                <Option value="Paid Internship">Paid Internship</Option>
                <Option value="Part time">Part time</Option>
                <Option value="Training">Training</Option>
                <Option value="Unpaid Internship">Unpaid Internship</Option>
                <Option value="Probation">Probation</Option>
              </Select>
            </Form.Item>
          </Col>

          {form.getFieldValue("employementtype") === "Probation" && (
            <>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  label="Probation Start Date"
                  name="probationstartdate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Probation Start Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Probation start date"
                    getPopupContainer={() => containerRef.current}

                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  label="Probation End Date"
                  name="probationenddate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Probation End Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Probation End date"
                    getPopupContainer={() => containerRef.current}

                  />
                </Form.Item>
              </Col>
            </>
          )}
          {form.getFieldValue("employementtype") === "Contract" && (
            <>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  label="Contract Start Date"
                  name="contractstartdate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Contract Start Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Contract start date"
                    getPopupContainer={() => containerRef.current}

                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  label="Contract End Date"
                  name="contractenddate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Contract End Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Contract End date"
                    getPopupContainer={() => containerRef.current}

                  />
                </Form.Item>
              </Col>
            </>
          )}

          <Col xs={24} sm={24} md={24}>
                <Form.Item name="description" label="Description">
                  <Input.TextArea
                    placeholder="description"
                  />
                </Form.Item>
              </Col>
        </StyleRow>
        <b className="my-2 ">Documents:</b>
        <StyleRow className="mt-2 mb-3" gutter={20}>
        <>
          <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="national_id"
                  label="National ID"
                  rules={[
                    {
                      required: true,
                      message: "National ID is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nationIDFile"
                  // label="file"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      validator: validateFiles,
                    },
                  ]}
                >
                  <Upload
                  accept=".pdf, image/*"
                    onRemove={() => {
                      form.resetFields(["nationIDFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("nationIDFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "nationalidDocument")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nationIDFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssf"
                  label="NSSF Number"
                  rules={[
                    { required: true, message: "NSSF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="NSSF Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssfFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    
                    {
                      validator: validateFiles,
                    },
                  ]}
                >
                  <Upload
                  accept=".pdf, image/*"
                    listType="text"
                    // name={["name", "attachment"]}
                    onChange={(file)=>handleUploadChange(file, "nssfDocument")}
                    onRemove={() => {
                      form.resetFields(["nssfFile"]);
                    }}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nssfFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
          </>
        </StyleRow>
        {/* <b className="my-2 ">Documents:</b>
        <StyleRow className="mt-2 mb-3" gutter={20}>
          <Col>
            <Form.Item
              name="country"
              label="Select country"
              rules={[{ required: true, message: "Please select a country!" }]}
            >
              <Button.Group>
                {["Kenya", "Uganda", "Tanzania", "Rwanda", "Ethiopia"].map(
                  (item) => (
                    <Button
                      key={item}
                      onClick={() => {
                        handleClick(item);
                        form.setFieldValue("country", item);
                      }}
                      style={{
                        backgroundColor:
                          selectedCountry === item
                            ? "#1890ff"
                            : "#F4F4F4",
                        color: "#000",
                      }}
                      disabled={selectedCountry !== ""}
                    >
                      {item}
                    </Button>
                  )
                )}
              </Button.Group>
            </Form.Item>
          </Col>
          <Col className="empty_col"></Col>

          <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="national_id"
                  label="National ID/Passport Number:"
                  rules={[
                    {
                      required: true,
                      message: "National ID/Passport Number is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nationIDFile"
                  // label="file"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "National ID/Passport File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["nationIDFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("nationIDFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "nationalid")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nationIDFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
          
          {selectedCountry === "Kenya" ? (
            <>
             
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="krapin"
                  label="KRA PIN Number"
                  rules={[
                    { required: true, message: "KRA PIN Number is required" },
                  ]}
                >
                  <Input
                    placeholder="KRA PIN Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="krapinFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["krapinFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("krapinFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "krapin")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("krapinFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nhif"
                  label="NHIF Number"
                  rules={[
                    { required: true, message: "NHIF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="NHIF Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  // label=""
                  name="nhifFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    listType="text"
                    onChange={(file)=>handleUploadChange(file, "nhif")}
                    onRemove={() => {
                      form.resetFields(["nhifFile"]);
                    }}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nhifFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssf"
                  label="NSSF Number"
                  rules={[
                    { required: true, message: "NSSF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="NSSF Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssfFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    listType="text"
                    // name={["name", "attachment"]}
                    onChange={(file)=>handleUploadChange(file, "nssf")}
                    onRemove={() => {
                      form.resetFields(["nssfFile"]);
                    }}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nssfFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
            </>
          ):
          selectedCountry === "Uganda" ? (
            <>            

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tin"
                  label="TIN Number:"
                  rules={[
                    { required: true, message: "TIN Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tinFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["tinFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("tinFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "tin")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("tinFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssf"
                  label="NSSF Number:"
                  rules={[
                    { required: true, message: "NSSF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssfFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["nssfFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("nssfFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "nssf")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nssfFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
             
            </>
          ):

          selectedCountry === "Tanzania" ? (
            <>              
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="wcf"
                  label="WCF Number:"
                  rules={[
                    { required: true, message: "WCF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="wcfFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["wcfFile"]);
                    }}
                    listType="text"
                    fileList={
                      form.getFieldValue("wcfFile")?.fileList || []
                    }
                    onChange={(file)=>handleUploadChange(file, "wcf")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("wcfFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nhif"
                  label="NHIF Number:"
                  rules={[
                    { required: true, message: "NHIF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nhifFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["nhifFile"]);
                    }}
                    listType="text"
                    fileList={
                      form.getFieldValue("nhifFile")?.fileList || []
                    }
                    onChange={(file)=>handleUploadChange(file, "nhif")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nhifFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssf"
                  label="NSSF Number:"
                  rules={[
                    { required: true, message: "NSSF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssfFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["nssfFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("nssfFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "nssf")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nssfFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tin"
                  label="TIN Number:"
                  rules={[
                    { required: true, message: "TIN Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tinFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["tinFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("tinFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "tin")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("tinFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>

              
            </>
          ):

          selectedCountry === "Rwanda" ? (
            <>
             
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tin"
                  label="TIN Number:"
                  rules={[
                    { required: true, message: "TIN Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tinFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["tinFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("tinFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "tin")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("tinFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="rssb"
                  label="RSSB Number:"
                  rules={[
                    { required: true, message: "RSSB Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="rssbFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["rssbFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("rssbFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "rssb")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("rssbFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
             
            </>
          ):
          selectedCountry === "Ethiopia" ? (
            <>
           
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="shi"
                  label="SHI Number:"
                  rules={[
                    { required: true, message: "SHI Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="shiFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["shiFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("shiFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "shi")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("shiFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="pssa"
                  label="PSSA Number:"
                  rules={[
                    { required: true, message: "PSSA Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="pssaFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["pssaFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("pssaFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "pssa")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("pssaFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tin"
                  label="TIN Number:"
                  rules={[
                    { required: true, message: "TIN Number is required" },
                  ]}
                >
                  <Input
                    placeholder="Enter No."
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="tinFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["tinFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("tinFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "tin")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("tinFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>

             
            </>
          ):
          <>             
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="krapin"
                  label="KRA PIN Number"
                  rules={[
                    { required: true, message: "KRA PIN Number is required" },
                  ]}
                >
                  <Input
                    placeholder="KRA PIN Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="krapinFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    onRemove={() => {
                      form.resetFields(["krapinFile"]);
                    }}
                    listType="text"
                    fileList={form.getFieldValue("krapinFile")?.fileList || []}
                    onChange={(file)=>handleUploadChange(file, "krapin")}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("krapinFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nhif"
                  label="NHIF Number"
                  rules={[
                    { required: true, message: "NHIF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="NHIF Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  // label=""
                  name="nhifFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                >
                  <Upload
                    listType="text"
                    onChange={(file)=>handleUploadChange(file, "nhif")}
                    onRemove={() => {
                      form.resetFields(["nhifFile"]);
                    }}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nhifFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssf"
                  label="NSSF Number"
                  rules={[
                    { required: true, message: "NSSF Number is required" },
                  ]}
                >
                  <Input
                    placeholder="NSSF Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nssfFile"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "File is required",
                    },
                  ]}
                  // rules={[
                  //   {
                  //     validator: (_, value) =>
                  //       fileList?.length > 0
                  //         ? Promise.resolve()
                  //         : Promise.reject(new Error("Please upload an image")),
                  //   },
                  // ]}
                >
                  <Upload
                    listType="text"
                    // name={["name", "attachment"]}
                    onChange={(file)=>handleUploadChange(file, "nssf")}
                    onRemove={() => {
                      form.resetFields(["nssfFile"]);
                    }}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("nssfFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn px-3">Attach File<span className="text-danger">*</span></div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>
              
            </>

            

        }
                      <Col xs={24} sm={24} md={24}>
                <Form.Item
                  label="Upload CV"
                  name="cvFile"
                  className="cv_file"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                  rules={[
                    {
                      required: true,
                      message: "CV is required",
                    },
                  ]}
                >
                  <Upload
                    listType="text"
                    // name={["name", "attachment"]}
                    onChange={(file)=>handleUploadChange(file, "CV")}
                    onRemove={() => {
                      form.resetFields(["cvFile"]);
                    }}
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    {!form.getFieldValue("cvFile")?.length > 0 ? (
                      <div>
                        <div className="w-100 attach_btn_cv px-3">
                          Attach File
                        </div>
                      </div>
                    ) : null}
                  </Upload>
                </Form.Item>
              </Col>

        </StyleRow> */}
        <div className="text-end"></div>
      </>
    </div>
  );
}

export default WorkDetails;
